import React, { useEffect, useState } from 'react';
import getUserDetails from '../firebase/authService';
import { useSelector } from 'react-redux';
import { fetchAllSites } from '../firebase/siteService';
import { fetchProjectData } from '../firebase/projectService';
import { fetchAllUsers } from '../firebase/userService';

const FirebaseTestPage = () => {
  const [, setRows] = useState([]);
  const [, setUsers] = useState([]);
  const user = useSelector((state) => state.auth.user);

useEffect(() => {
    getUserDetails(); // Call function to log user details
}, []);

useEffect(() => {
  const getUsers = async () => {
    const fetchedUsers = await fetchAllUsers();
    console.log('Fetched Users:', fetchedUsers);
    setUsers(fetchedUsers);
  };

  getUsers();
}, []);

useEffect(() => {
  const getSites = async () => {
    await fetchAllSites();
    // console.log('Fetched Sites:', sites);
  };
  getSites();
}, []);

useEffect(() => {
  let unsubscribe;


  if (user) {
    console.log(user.projectId);
    unsubscribe = fetchProjectData(user.role, user.projectId, (data) => {
      console.log('Fetched Project Data:', data); // Console log the fetched data
      setRows(data);
    });
  }

  return () => {
    if (unsubscribe) unsubscribe();
  };
}, [user]);

// console.log(user.role);

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold">Firebase Test Page</h1>
      <p>Open the console to see the fetched data.</p>
    </div>
  );
};

export default FirebaseTestPage;
